import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_mst_item_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_line_guid: fromDatatype.GuidDataFieldInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_inv_mst_item_ext_RowClass
  implements bl_inv_mst_item_ext_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  inv_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_line_guid: fromDatatype.GuidDataFieldInterface;
  ext_type: fromDatatype.VarcharDatatypeInterface;
  ext_code: fromDatatype.VarcharDatatypeInterface;
  ext_option: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  param_code: fromDatatype.VarcharDatatypeInterface;
  param_name: fromDatatype.VarcharDatatypeInterface;
  param_type: fromDatatype.VarcharDatatypeInterface;
  param_option_json: fromDatatype.JsonDatatypeInterface;
  value_string: fromDatatype.TextDatatypeInterface;
  value_file: fromDatatype.VarcharDatatypeInterface;
  value_numeric: fromDatatype.NumericDatatypeInterface;
  value_datetime: fromDatatype.TimestampTzDatatypeInterface;
  value_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
